
var filterCountryStudy = $('#filter_country_study')
var filterUniversity = $('#filter_university')
var filterCareerArea = $('#filter_career_area')
var filterCareer = $('#filter_career')
var filterNationality = $('#filter_nationality')
var filterCountry = $('#filter_co')
var filterRegion = $('#filter_re')
var filterProvince = $('#filter_st')
var filterCiudad = $('#filter_ci')

const config = require('../../../../../config/locales_json/packs/private/postulations/postulations.json');
const language = $('body').data("language");


initSpecifiqFilters()

function initSpecifiqFilters() {
  const filters = [filterCountryStudy, filterUniversity, filterCareerArea, filterCareer, filterNationality, filterCountry, filterRegion, filterProvince, filterCiudad]

  const filtersSelectize = $("#fj_postulations_filter .selectize-select");

  $.each(filtersSelectize, function(index, filter) {
    const filterObject = $(filter);
    if(filterObject.length > 0){
      filterObject.selectize({
        create: false
      });
    }
  });
}

// /*************
// * Cambios de estado
// *
// */
// jQuery(function() {

//   /*************
//   *
//   * Cambios de estado individual por medio del dropdonw
//   * Usamos un detector de eventos encadenado al div superior, porque se vuelve a renderear la fila de la tabla
//   */

//   $('#postulantTabs a').on('click', function (e) {
//     e.preventDefault();
//     $(this).tab('show');
//   });

//   $("div#postulation-list, #profileModal").on("click", "a.change_state_link", function(e){
//     e.preventDefault();

//     // conseguimos el csrf-token
//     var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
//     var stateLink = $(this);
//     var postulationId = stateLink.data('postulation');
//     var postulationList = $('#postulants tbody tr');
//     var postulationIndex =  postulationList.index($('#postulant-'+postulationId));
//     var postulationCount = postulationList.length;

//     if (stateLink.data('send-mail')){
//       const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_1"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", inputPlaceholder: "Enviar correo de cambio de estado", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });

// 			Swal.fire({
// 				title: swalFireInfo['title'],
// 				icon: 'question',
// 				input: 'checkbox',
// 				inputPlaceholder: swalFireInfo['inputPlaceholder'],
// 				confirmButtonText: swalFireInfo['confirmButtonText'],
// 				showCancelButton: true,
// 				cancelButtonText: swalFireInfo['cancelButtonText'],
// 				width: '50rem',
// 				padding: '2rem'
// 			}).then(function(result) {
//         // Revisamos si la tabla es del admin
//         var checkAdminUser = $("#list_postulations #postulants").hasClass("admin")
//         // Si es el admin
//         if(checkAdminUser) {
//           var slug = $("#list_postulations #postulants").attr("data-slug")
//           var url = '/admin/clientes/'+ slug +'/ofertas/' + stateLink.data('ofert') + '/postulaciones/'+ stateLink.data('postulation')+'/change_funnel_state'
//         } else {
//           var url = '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/'+ stateLink.data('postulation')+'/change_funnel_state'
//         }

// 				if (result.value) {

//           $.ajax({
// 						type: "POST",
// 						url: url,
// 						dataType: 'script',
// 						data: {
// 							postulation_id: stateLink.data('postulation'),
// 							new_state: stateLink.data('funnel-workflow'),
//               send_mail: 'si',
//               slug: slug,
//               postulation_index: postulationIndex,
//               postulation_count: postulationCount,
//               authenticity_token: AUTH_TOKEN
// 						}
// 					});

// 				} else if (result.value === 0) {
//           $.ajax({
// 						type: "POST",
// 						url: url,
// 						dataType: 'script',
// 						data: {
// 							postulation_id: stateLink.data('postulation'),
// 							new_state: stateLink.data('funnel-workflow'),
//               send_mail: 'no',
//               slug: slug,
//               postulation_index: postulationIndex,
//               postulation_count: postulationCount,
//               authenticity_token: AUTH_TOKEN
// 						}
// 					});

// 				} else {
// 					//console.log('modal was dismissed by ${result.dismiss}')
// 				}
// 			})
// 		}else{
//       const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_2"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });

// 			Swal.fire({
// 				title: swalFireInfo['title'],
// 				icon: 'question',
// 				confirmButtonText: swalFireInfo['confirmButtonText'],
// 				showCancelButton: true,
// 				cancelButtonText: swalFireInfo['cancelButtonText'],
// 				width: '50rem',
// 				padding: '2rem'
// 			}).then(function(result) {
// 				if (result.isConfirmed) {
//           // Revisamos si la tabla es del admin
//           var checkAdminUser = $("#list_postulations #postulants").hasClass("admin")
//           // Si es el admin
//           if(checkAdminUser) {
//             var slug = $("#list_postulations #postulants").attr("data-slug")
//             var url = '/admin/clientes/'+ slug +'/ofertas/' + stateLink.data('ofert') + '/postulaciones/'+ stateLink.data('postulation')+'/change_funnel_state'
//           } else {
//             var url = '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/'+ stateLink.data('postulation')+'/change_funnel_state'
//           }

// 					$.ajax({
// 						type: "POST",
// 						url: url,
// 						dataType: 'script',
// 						data: {
// 							postulation_id: stateLink.data('postulation'),
// 							new_state: stateLink.data('funnel-workflow'),
//               send_mail: 'no',
//               authenticity_token: AUTH_TOKEN,
//               postulation_index: postulationIndex,
//               postulation_count: postulationCount,
//               slug: slug,
// 						}
// 					});

// 				} else {
// 					//console.log('modal was dismissed by '+result.dismiss)
// 				}
// 			})
// 		}
//   });

//   /*************
//   *
//   * Cambios de estado Massivo por medio del dropdonw
//   * Usamos un detector de eventos encadenado al div superior, porque se vuelve a renderear la fila de la tabla
//   */

//   $("div#postulation-list").on("click", "a.change_massive_state_link", function(e){
//     e.preventDefault();

//     // conseguimos el csrf-token
//     var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
//     var stateLink = $(this);

//     const jobId = $("#list_postulations").data("job");

//     if (stateLink.data('send-mail')){
//       const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_2"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", inputPlaceholder: "Enviar correo de cambio de estado", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });

//       Swal.fire({
//         title: swalFireInfo['title'],
//         icon: 'question',
//         input: 'checkbox',
//         inputPlaceholder: swalFireInfo['inputPlaceholder'],
//         confirmButtonText: swalFireInfo['confirmButtonText'],
//         showCancelButton: true,
//         cancelButtonText: swalFireInfo['cancelButtonText'],
//         width: '50rem',
//         padding: '2rem'
//       }).then(function(result) {
//         // Revisamos si la tabla es del admin
//         var checkAdminUser = $("#list_postulations #postulants").hasClass("admin")
//         // Si es el admin
//         if(checkAdminUser) {
//           var slug = $("#list_postulations #postulants").attr("data-slug")
//           var url = '/admin/clientes/'+ slug +'/ofertas/' + stateLink.data('ofert') + '/postulaciones/change_massive_funnel_state'
//         } else {
//           var url = '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/change_massive_funnel_state'
//         }

//         if (result.value) {

//           $.ajax({
//             type: "POST",
//             url: url,
//             dataType: 'script',
//             data: {
//               postulation_ids: localStorage.getItem("postulantIds_"+jobId),
//               new_state: stateLink.data('funnel-workflow'),
//               send_mail: 'si',
//               slug: slug,
//               authenticity_token: AUTH_TOKEN
//             }
//           });

//         } else if (result.value === 0) {
//           $.ajax({
//             type: "POST",
//             url: url,
//             dataType: 'script',
//             data: {
//               postulation_ids: localStorage.getItem("postulantIds_"+jobId),
//               new_state: stateLink.data('funnel-workflow'),
//               send_mail: 'no',
//               slug: slug,
//               authenticity_token: AUTH_TOKEN
//             }
//           });

//         } else {
//           //console.log('modal was dismissed by ${result.dismiss}')
//         }
//       })

//     } else {
//       const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_2"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });

//       Swal.fire({
//         title: swalFireInfo['title'],
//         icon: 'question',
//         confirmButtonText: swalFireInfo['confirmButtonText'],
//         showCancelButton: true,
//         cancelButtonText: swalFireInfo['cancelButtonText'],
//         width: '50rem',
//         padding: '2rem'
//       }).then(function(result) {
//         if (result.isConfirmed) {
//           // Revisamos si la tabla es del admin
//           var checkAdminUser = $("#list_postulations #postulants").hasClass("admin")
//           // Si es el admin
//           if(checkAdminUser) {
//             var slug = $("#list_postulations #postulants").attr("data-slug")
//             var url = '/admin/clientes/'+ slug +'/ofertas/' + stateLink.data('ofert') + '/postulaciones/change_massive_funnel_state'
//           } else {
//             var url = '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/change_massive_funnel_state'
//           }

//           $.ajax({
//             type: "POST",
//             url: url,
//             dataType: 'script',
//             data: {
//               postulation_ids: localStorage.getItem("postulantIds_"+jobId),
//               new_state: stateLink.data('funnel-workflow'),
//               send_mail: 'no',
//               slug: slug,
//               authenticity_token: AUTH_TOKEN
//             }
//           });

//         } else {
//           //console.log('modal was dismissed by '+result.dismiss)
//         }
//       })
//     }
//   });


// });

// /*************
// * Cambios de estado MASIVO
// *
// */
// jQuery(function() {

//   /****************
//   * Validando si la variable de los postulantes esta vacia, se bloquea el dropdown de los estados
//   * Sino se deja habilitado
//   */
//   const jobId = $("#list_postulations").data("job");

//   if (localStorage.getItem("postulantIds_"+jobId) == null || localStorage.getItem("postulantIds_"+jobId) === '' || localStorage.getItem("postulantIds_"+jobId) === 'null') {
//     localStorage.setItem("postulantIdsSelectAll"+jobId, false);
//     $('input#check_for_select_all').prop("checked", false);
//     $('button#menu_bulk_action').prop('disabled', true)
//     //$('a#link_download_selected').css('display','none');
//     $('a#link_download_selected_mail').css('display','none');
//     $('button#menu_bulk_action').addClass('disabled')
//   }else{
//     $('button#menu_bulk_action').prop('disabled', false);
//     //$('a#link_download_selected').css('display','block');
//     $('a#link_download_selected_mail').css('display','inline-flex');
//     $('button#menu_bulk_action').removeClass('disabled');
//   }

//   /****************
//   * si la variable de los postulantes tiene valores, se seleccionan los checkbox correspondientes
//   */

//   if (localStorage.getItem("postulantIds_"+jobId) !== null) {
//     var selectedOnReloadPostulants = localStorage.getItem("postulantIds_"+jobId).split(',')
//     $.each(selectedOnReloadPostulants, function(index, value) {
//       $('#check_for_postulant_'+value).prop("checked", true);
//     });
//   }

//   /****************
//   * si la variable de seleccion de todos los postulantes es true, se selecciona el checkbox
//   */

//   if (localStorage.getItem("postulantIdsSelectAll"+jobId) === "true") {
// 		$('input#check_for_select_all').prop("checked", true);
// 	}

//   /****************
//   * Evento que permite guardar y seleccionar todos los ids de los postulantes
//   */
//   $('input#check_for_select_all').on('change', function(e){
//     // alert($("input[name='check_for_postulant']:checked").length);
//     if ($(this).is(':checked')) {
//       if ($("input[name='check_for_postulant']:checked").length > 0){
//         localStorage.setItem("postulantIdsSelectAll"+jobId, false);
//         localStorage.setItem("postulantIds_"+jobId, null);
//         $('input.check_postulant').prop("checked", false);
//         $('button#menu_bulk_action').prop('disabled', true);
//         //$('a#link_download_selected').css('display','none');
//         $('a#link_download_selected_mail').css('display','none');
//         $('button#menu_bulk_action').addClass('disabled');
//         $(this).prop("checked", false);
//       } else {
//         // Contiene todo lo que devuelve la db, ya sea todos o los filtrados
//         var all_id_array= $('input#all_ids').val();

//         // Contiene solo lo que se muestra en la tabla
//         //var all_id_array = get_all_ids_from_table();

//         localStorage.setItem("postulantIdsSelectAll"+jobId, true);
//         localStorage.setItem("postulantIds_"+jobId, all_id_array);
//         $('input.check_postulant').prop("checked", true);
//         $('button#menu_bulk_action').prop('disabled', false);
//         //$('a#link_download_selected').css('display','block');
//         $('a#link_download_selected_mail').css('display','inline-flex');
//         $('button#menu_bulk_action').removeClass('disabled');
//       }
// 		} else {
// 			localStorage.setItem("postulantIdsSelectAll"+jobId, false);
// 			localStorage.setItem("postulantIds_"+jobId, null);
//       $('input.check_postulant').prop("checked", false);
//       $('button#menu_bulk_action').prop('disabled', true);
//       //$('a#link_download_selected').css('display','none');
//       $('a#link_download_selected_mail').css('display','none');
// 			$('button#menu_bulk_action').addClass('disabled');
// 		}

// 	});

//   function get_all_ids_from_table() {
//     var all_id_array = ""
//     $("table.postulaciones tbody tr").each(function(index, element){
//       var attrId = $(element).attr('id');
//       var id = attrId.split('-')[1];

//       if (index === 0) {
//         all_id_array = id;
//       } else {
//         all_id_array = all_id_array + ',' + id;
//       }
//     });

//     return all_id_array;
//   }

//   /****************
//   * Evento que permite ir guardando y checkeando postulantes individuales
//   */
//   $("div#postulation-list").on("click", "input.check_postulant", function() {
// 		getPostulantsIds($(this).val())
// 		candidatesIds = localStorage.getItem("postulantIds_"+jobId);
// 		if (localStorage.getItem("postulantIds_"+jobId) == null || localStorage.getItem("postulantIds_"+jobId) === ''){
//       $('button#menu_bulk_action').prop('disabled', true)
//       //$('a#link_download_selected').css('display','none');
//       $('a#link_download_selected_mail').css('display','none');
// 			$('button#menu_bulk_action').addClass('disabled')
// 		}else{
//       $('button#menu_bulk_action').prop('disabled', false);
//       //$('a#link_download_selected').css('display','block');
//       $('a#link_download_selected_mail').css('display','inline-flex');
// 			$('button#menu_bulk_action').removeClass('disabled');
// 		}
//   });


//   // Funcion para Enivar al email los seleccionados
//   $("div#list_postulations").on("click", "a#link_download_selected_mail", function(e) {
//     e.preventDefault();
//     var link_selected= $(this);
//     candidatesIds = localStorage.getItem("postulantIds_"+jobId);
//     var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

//     // Revisamos si la tabla es del admin
//     var checkAdminUser = $("#list_postulations #postulants").hasClass("admin")
//     // Si es el admin
//     if(checkAdminUser) {
//       var slug = $("#list_postulations #postulants").attr("data-slug")
//       var url = '/admin/clientes/'+ slug +'/ofertas/' + link_selected.data('ofert-id') + '/send_selected_postulants'
//     } else {
//       var url = '/empresa/ofertas/' + link_selected.data('ofert-id') + '/send_selected_postulants'
//     }

//     $.ajax({
//       type: "GET",
//       url: url,
//       dataType: 'script',
//       data: {
//         ids: candidatesIds,
//         authenticity_token: AUTH_TOKEN
//       }
//     });
//   });


// });

// // Funcion que se ejecuta al clickear un checkbox en postulantes
// function getPostulantsIds(value) {
//   const jobId = $("#list_postulations").data("job");

// 	var allVals = []
//   var stored_ids = localStorage.getItem("postulantIds_"+jobId);
//   // debugger;
// 	if (!(stored_ids === "null" || stored_ids === null|| stored_ids === '')) {
//     allVals = stored_ids.split(',')
// 	}
// 	if ($.inArray(value, allVals) >= 0) {
//     allVals.splice( $.inArray(value, allVals), 1 );
// 	}else {
//     allVals.push(value)
//   }

//   // Removiendo los nullos
//   var filteredallVals = allVals.filter(function (el) {
//     return (el != "null" || el != "");
//   });

//   localStorage.setItem("postulantIds_"+jobId, filteredallVals.join(','))

//   // Si todos los checkbox seleccionados son igual/diferentes que el numero de ids de la consulta
//   //que marque/desmarque el checkbox de select all

//   if (filteredallVals.length === $('input#all_ids').val().split(',').length ){
//     $('input#check_for_select_all').prop("checked", true);
//     localStorage.setItem("postulantIdsSelectAll"+jobId, true);
//   }else{
//     $('input#check_for_select_all').prop("checked", false);
//     localStorage.setItem("postulantIdsSelectAll"+jobId, false);
//   }

// 	return filteredallVals
// }

jQuery(function() {
  const jobId = $("#list_postulations").data("job");

  // Función para manejar la selección de todos los postulantes en una pestaña específica
  function handleSelectAll(tabId, selectAllId, allIdsName) {
    $('#' + selectAllId).on('change', function(e){
      var allIds = $('#' + allIdsName).val();
      if ($(this).is(':checked')) {
        localStorage.setItem("postulantIds_" + tabId + "_" + jobId, allIds);
        $('#' + tabId + ' input.check_postulant').prop("checked", true);
      } else {
        localStorage.setItem("postulantIds_" + tabId + "_" + jobId, '');
        $('#' + tabId + ' input.check_postulant').prop("checked", false);
      }
      updateBulkActionButtonState();
    });
  }

  // Función para manejar la selección individual de postulantes en una pestaña específica
  function handleIndividualSelect(tabId) {
    $("#" + tabId).on("click", "input.check_postulant", function() {
      var value = $(this).val();
      var storedIds = localStorage.getItem("postulantIds_" + tabId + "_" + jobId) || '';
      var allVals = storedIds === '' ? [] : storedIds.split(',');

      if (allVals.includes(value)) {
        allVals = allVals.filter(val => val !== value);
      } else {
        allVals.push(value);
      }

      localStorage.setItem("postulantIds_" + tabId + "_" + jobId, allVals.join(','));
      $('#' + tabId + ' input#check_for_select_all').prop("checked", allVals.length === $('#' + tabId + ' input.check_postulant').length);
      updateBulkActionButtonState();
    });
  }

  // Función para actualizar el estado del botón de acción masiva
  function updateBulkActionButtonState() {
    var fulfillIds = localStorage.getItem("postulantIds_postulants-fulfill_" + jobId);
    var noFulfillIds = localStorage.getItem("postulantIds_postulants-no-fulfill_" + jobId);
    var noTabsIds = localStorage.getItem("postulantIds_postulants_" + jobId);
    var button = $('button#menu_bulk_action');

    if ((!fulfillIds || fulfillIds === '') && (!noFulfillIds || noFulfillIds === '') && (!noTabsIds || noTabsIds === '')) {
      button.prop('disabled', true);
      button.addClass('disabled');
      $('a#link_download_selected_mail').css('display', 'none');
      $('a#selected_hirint_remainder').css('display', 'none');
      $('a#massive_hirint_remainder').css('display', 'inline-flex');
    } else {
      button.prop('disabled', false);
      button.removeClass('disabled');
      $('a#link_download_selected_mail').css('display', 'inline-flex');
      $('a#selected_hirint_remainder').css('display', 'inline-flex');
      $('a#massive_hirint_remainder').css('display', 'none');
    }
  }

  handleSelectAll('postulants-fulfill', 'check_for_select_all_fulfill', 'all_ids_fulfill');
  handleSelectAll('postulants-no-fulfill', 'check_for_select_all_no_fulfill', 'all_ids_no_fulfill');
  handleSelectAll('postulants', 'check_for_select_all_no_tabs', 'all_ids_no_tabs');

  handleIndividualSelect('postulants-fulfill');
  handleIndividualSelect('postulants-no-fulfill');
  handleIndividualSelect('postulants');

  // Inicialización del estado de los botones y checkboxes al cargar la página
  updateBulkActionButtonState();

  // Evento para cambio masivo de estado
  $("div#postulation-list").on("click", "a.change_massive_state_link", function(e){
    e.preventDefault();
    
    var stateLink = $(this);
    var newStateLabel = stateLink.data('funnel-label');

    const fulfillIds = localStorage.getItem("postulantIds_postulants-fulfill_" + jobId);
    const noFulfillIds = localStorage.getItem("postulantIds_postulants-no-fulfill_" + jobId);
    const noTabsIds = localStorage.getItem("postulantIds_postulants_" + jobId);
    const combinedIds = [...(fulfillIds ? fulfillIds.split(',') : []), ...(noFulfillIds ? noFulfillIds.split(',') : []), ...(noTabsIds ? noTabsIds.split(',') : [])].join(',');

    if (combinedIds.length === 0) {
      Swal.fire({
        title: "No hay postulantes seleccionados",
        icon: 'error',
        confirmButtonText: "Ok",
        width: '50rem',
        padding: '2rem'
      });
      return;
    }

    if (stateLink.data('send-mail')){
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_massive_state_link", "Swalfire_1"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", inputPlaceholder: "Enviar correo de cambio de estado", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      var newstate = stateLink.data('funnel-workflow');
      var showPreview = stateLink.data('feature-flag');
      
      // Se hace la petición para obtener el asunto y el correo correspondiente al cambio de funnel
      $.ajax({
        type: "GET",
        url: "/settings/fw/email/"+newstate,
        dataType: 'json'
      }).done(function(response, textStatus, jqXHR) {
        let data = response.data;
        swalFireChangeMassiveStatus(swalFireInfo, stateLink, combinedIds, newStateLabel, data, showPreview);
      }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error(errorThrown);
        swalFireChangeMassiveStatus(swalFireInfo, stateLink, combinedIds, newStateLabel);
      })
    } else {
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_massive_state_link", "Swalfire_2"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      swalFireChangeMassiveStatus(swalFireInfo, stateLink, combinedIds, newStateLabel);
    }
  });

  // Evento para cambio individual de estado
  $("div#postulation-list, #profileModal").on("click", "a.change_state_link", function(e){
    e.preventDefault();

    var stateLink = $(this);
    var newStateLabel = stateLink.data('funnel-label');

    if (stateLink.data('send-mail')){
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_1"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", inputPlaceholder: "Enviar correo de cambio de estado", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      var newstate = stateLink.data('funnel-workflow');
      var showPreview = stateLink.data('feature-flag');

      // Se hace la petición para obtener el asunto y el correo correspondiente al cambio de funnel
      $.ajax({
        type: "GET",
        url: "/settings/fw/email/"+newstate,
        dataType: 'json'
      }).done(function(response, textStatus, jqXHR) {
        let data = response.data;
        swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel, data, showPreview);
      }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error(errorThrown);
        swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel);
      })
    } else {
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_2"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel);
    }
  });

  // Evento para enviar postulantes seleccionados por email
  $("div#list_postulations").on("click", "a#link_download_selected_mail", function(e) {
    e.preventDefault();
    var linkSelected = $(this);
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var { isAdminUser, slug } = getSlugAndAdminStatus();
    const fulfillIds = localStorage.getItem("postulantIds_postulants-fulfill_" + jobId);
    const noFulfillIds = localStorage.getItem("postulantIds_postulants-no-fulfill_" + jobId);
    const noTabsIds = localStorage.getItem("postulantIds_postulants_" + jobId);
    const combinedIds = [...(fulfillIds ? fulfillIds.split(',') : []), ...(noFulfillIds ? noFulfillIds.split(',') : []), ...(noTabsIds ? noTabsIds.split(',') : [])].join(',');

    if (combinedIds.length === 0) {
      Swal.fire({
        title: "No hay postulantes seleccionados",
        icon: 'error',
        confirmButtonText: "Ok",
        width: '50rem',
        padding: '2rem'
      });
      return;
    }

    var url = isAdminUser
      ? '/admin/clientes/' + slug + '/ofertas/' + linkSelected.data('ofert-id') + '/send_selected_postulants'
      : '/empresa/ofertas/' + linkSelected.data('ofert-id') + '/send_selected_postulants';

    $.ajax({
      type: "GET",
      url: url,
      dataType: 'script',
      data: {
        ids: combinedIds,
        authenticity_token: AUTH_TOKEN
      }
    });
  });

  // Inicializar estados de checkboxes al cargar la página
  const fulfillCheckboxes = localStorage.getItem("postulantIds_postulants-fulfill_" + jobId);
  if (fulfillCheckboxes) {
    fulfillCheckboxes.split(',').forEach(id => {
      $('#postulants-fulfill #check_for_postulant_' + id).prop("checked", true);
    });
  }

  const noFulfillCheckboxes = localStorage.getItem("postulantIds_postulants-no-fulfill_" + jobId);
  if (noFulfillCheckboxes) {
    noFulfillCheckboxes.split(',').forEach(id => {
      $('#postulants-no-fulfill #check_for_postulant_' + id).prop("checked", true);
    });
  }

  const noTabsCheckboxes = localStorage.getItem("postulantIds_postulants_" + jobId);
  if (noTabsCheckboxes) {
    noTabsCheckboxes.split(',').forEach(id => {
      $('#postulants #check_for_postulant_' + id).prop("checked", true);
    });
  }

  updateBulkActionButtonState();

  /*************
  *
  * Manejo de la acción de mostrar u ocultar el preview del correo
  */

  $(document).on('click', '#preview-button-email', function() {
    let emailPreviewContainer = $('#email-preview');
    let previewBtn = $('#preview-button-email');

    const showPreviewText = getTranslationValue(config, [language, "preview_email_btn", "show"], "Preview del Correo");
    const hidePreviewText = getTranslationValue(config, [language, "preview_email_btn", "hide"], "Octular Preview");

    if (emailPreviewContainer.length) {
      let display = emailPreviewContainer.css('display');
      
      if (display === 'block') {
        emailPreviewContainer.css('display', 'none');
        previewBtn.text(showPreviewText);
      } else if (display === 'none') {
        emailPreviewContainer.css('display', 'block');
        previewBtn.text(hidePreviewText);
      } else {
        emailPreviewContainer.css('display', 'none');
        previewBtn.text(showPreviewText);
      }
    }
  });
  
});

$(document).ready(function() {

  $('div#isfavoriteModal').on("click", "#change_favorite", function(e){
    const disabledText = getTranslationValue(config, [language, "on_click_change_favorite_text"], "Enviando Información...");
    $(this).addClass("disabled").text(disabledText);
		$("div#isfavoriteModal").addClass("disabled");
	})

  $('div#postulation-list, #profileModal').on("click", "#sendHirintEmailButton", function(e){
    var postulation_id = $(this).data('postulation-id');
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

    Swal.fire({
      title: '¡Atención!',
      text: '¿Está seguro de enviar el correo?',
      icon: 'warning',
      allowEscapeKey: false,
      allowEnterKey: false,
      buttonsStyling: false,
      allowOutsideClick: false,
      confirmButtonText: 'Enviar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      customClass: {
          confirmButton: "btn btn-fj-purple",
          cancelButton: "btn btn-light"
      }
    }).then((result) => {
        if (result.isConfirmed) {
          // Realizar la activación o desactivación del servicio
          sendHirintEmailAction(postulation_id, AUTH_TOKEN)
        }
    });

  });

  function sendHirintEmailAction(postulation_id, AUTH_TOKEN) {
    Swal.fire({
      title: 'Realizando acción...',
      text: "Por favor espere mientras se procesa la acción",
      icon: 'info',
      allowEscapeKey: false,
      allowEnterKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });
    // Consulta AJAX para activar o desactivar el servicio
    $.ajax({
      type: 'POST',
      url: '/send_hirint_email',
      dataType: 'script',
      data: {
        postulation_id: postulation_id,
        authenticity_token: AUTH_TOKEN
      },
      success: function(response, textStatus, jqXHR) {
        Swal.fire({
          title: '¡Correo Enviado!',
          text: 'El correo se ha enviado correctamente.',
          icon: 'success',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-fj-purple",
          }
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Muestra alerta indicando que hubo un error
        Swal.fire({
          text: 'Hubo un problema al enviar el correo. Por favor vuelve a intentar en unos minutos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
      }
    });
  }

  $('div#postulation-list, #profileModal').on("click", "#activateHirint", function(e){
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var client_name = $(this).data('client-name');
    var client_countrie = $(this).data('client-country');

    Swal.fire({
      title: '¡Atención!',
      text: '¿Está seguro de solicitar el servicio?',
      icon: 'warning',
      allowEscapeKey: false,
      allowEnterKey: false,
      buttonsStyling: false,
      allowOutsideClick: false,
      confirmButtonText: 'Solicitar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      customClass: {
          confirmButton: "btn btn-fj-purple",
          cancelButton: "btn btn-light"
      }
    }).then((result) => {
      if (result.isConfirmed) {
        //Realizar la activación o desactivación del servicio
        sendHirintActivateSlack(client_name, client_countrie, AUTH_TOKEN)
      }
    });
  });

  function sendHirintActivateSlack(client_name, client_countrie, AUTH_TOKEN) {
    Swal.fire({
      title: 'Realizando acción...',
      text: "Por favor espere mientras se procesa la acción",
      icon: 'info',
      allowEscapeKey: false,
      allowEnterKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });
    // Consulta AJAX para activar o desactivar el servicio
    $.ajax({
      type: 'POST',
      url: '/callback_slack_activate_hirint',
      dataType: 'json',
      data: {
        client_name: client_name,
        client_countrie: client_countrie,
        authenticity_token: AUTH_TOKEN
      },
      success: function(response, textStatus, jqXHR) {
        Swal.fire({
          title: '¡Solicitaste el servicio!',
          text: 'Alguien del equipo comercial te estará contactando próximamente.',
          icon: 'success',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-fj-purple",
          }
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Muestra alerta indicando que hubo un error
        Swal.fire({
          text: 'Hubo un problema al solicitarlo. Por favor vuelve a intentar en unos minutos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
      }
    });
  }

  $('div#profileModal').on("show.bs.modal", function(e){
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var active_panel = $("#hirint.active.no-report")

    if (active_panel.length > 0) {
      var user_id = active_panel.data('userid');

      $.ajax({
        type: 'GET',
        url: '/get_hirint_test',
        dataType: 'script',
        data: {
          user_id: user_id,
          authenticity_token: AUTH_TOKEN
        },
        beforeSend: function() {
          // Muestra el mensaje "Cargando" usando SweetAlert2
          Swal.fire({
            title: 'Cargando Información',
            icon: 'info',
            allowEscapeKey: false,
            allowEnterKey: false,
            buttonsStyling: false,
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false
          });
        },
        success: function(response, textStatus, jqXHR) {
          Swal.close();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          // Muestra alerta indicando que hubo un error
          Swal.fire({
            text: 'Hubo un problema al cargar el reporte. Por favor vuelve a intentar en unos minutos.',
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn btn-fj-purple"
            }
          });
        }
      });
    }
  })


  $('div#profileModal').on("click", "#hirintModalTab.no-report", function(e){
    var user_id = $(this).data('userid');
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

    $.ajax({
      type: 'GET',
      url: '/get_hirint_test',
      dataType: 'script',
      data: {
        user_id: user_id,
        authenticity_token: AUTH_TOKEN
      },
      beforeSend: function() {
        // Muestra el mensaje "Cargando" usando SweetAlert2
        Swal.fire({
          title: 'Cargando Información',
          icon: 'info',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false
        });
      },
      success: function(response, textStatus, jqXHR) {
        Swal.close();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Muestra alerta indicando que hubo un error
        Swal.fire({
          text: 'Hubo un problema al cargar el reporte. Por favor vuelve a intentar en unos minutos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
      }
    });



  });

  $('div#profileModal').on('shown.bs.modal', function (e) {
    handleModalFooterSwipeButtons();
  })

  $('div#profileModal').on("click", "#swipe-actions button.swipe-btn", function(e) {
    var btn = $(this);
    swipeToRequest(btn);
  })

  $('div#profileModal').on("click", "#modal-footer-swipe-actions button.swipe-btn", function(e) {
    var clickedBtn = $(this);
    var swipeToNext = clickedBtn.hasClass('next');
    
    var swipeToBtnAction = swipeToNext ? $('#swipe-actions button.swipe-btn.next') : $('#swipe-actions button.swipe-btn.previous');
    if (swipeToBtnAction.length > 0) swipeToRequest(swipeToBtnAction);
  })

  // Evento para modificar url de acciones swipe
  $('div#profileModal').on("click", ".card-header.card-header-tabs-line a.nav-link", function(e) {
    var tabResume = $(this);
    var resumeParamValue = tabResume.data('resume');
    var swipeBtns = $('div#profileModal #swipe-actions button.swipe-btn');
    if (![null, undefined].includes(resumeParamValue) && swipeBtns.length > 0 ) {
      swipeBtns.each(function() {
        var btn = $(this);
        var oldHref = btn.data('href');
        btn.data('href', updateQueryParam(oldHref, 'resume', resumeParamValue));
      });
    }
  })

})

$(document).ready(function() {
  $(".dropdown-hirint-massive-reminders").on("click", ".btn-hirint-massive-reminders", function(e) {
    e.preventDefault();
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var btn = $(this);
    let sendAll = [true, "true"].includes(btn.data("all"));
    let lang = language ? language : "es";

    let postulantIds = sendAll ? [] : getSelectedPostulations();

    if (!sendAll && postulantIds.length === 0) {
      Swal.fire({
        title: "No hay postulantes seleccionados",
        icon: 'error',
        confirmButtonText: "Ok",
        width: '50rem',
        padding: '2rem'
      });
      return;
    }

    const hirintReminderTranslation = {
      "es": {
        "title": "¿Está seguro que quiere enviar recordatorio a todos los postulantes que no han respondido Hirint?",
        "titleMassive": "¿Está seguro que quiere enviar recordatorio a los [--nPostulants--] postulantes seleccionados?",
        "confirmButtonText": "Sí",
        "cancelButtonText": "No"
      },
      "en": {
        "title": "Are you sure you want to send a reminder to all applicants who have not responded to Hirint?",
        "titleMassive": "Are you sure you want to send a reminder to the [--nPostulants--] selected applicants?",
        "confirmButtonText": "Yes",
        "cancelButtonText": "No"
      },
      "pt": {
        "title": "Tem certeza de que deseja enviar um lembrete para todos os candidatos que não responderam ao Hirint?",
        "titleMassive": "Tem certeza de que deseja enviar um lembrete para os [--nPostulants--] candidatos selecionados?",
        "confirmButtonText": "Sim",
        "cancelButtonText": "Não"
      }
    }

    Swal.fire({
      title: sendAll ?  hirintReminderTranslation[lang].title : hirintReminderTranslation[lang].titleMassive.replace("[--nPostulants--]", postulantIds.length),
      icon: 'question',
      confirmButtonText: hirintReminderTranslation[lang].confirmButtonText,
      showCancelButton: true,
      cancelButtonText: hirintReminderTranslation[lang].cancelButtonText,
    })
    .then(function(result) {
      if (result.isConfirmed) {
        // Se hace la petición para iniciar el envío de correos
        $.ajax({
          type: "POST",
          url: "/hirint/send_massive_reminders",
          dataType: 'json',
          data: {
            authenticity_token: AUTH_TOKEN,
            postulation_ids: postulantIds,
            send_all: sendAll,
            ofert_id: btn.data("ofert-id")
          },
          beforeSend: function() {
            // Muestra el mensaje "Cargando" usando SweetAlert2
            Swal.fire({
              title: 'Iniciando envío...',
              icon: 'info',
              allowEscapeKey: false,
              allowEnterKey: false,
              buttonsStyling: false,
              allowOutsideClick: false,
              showCancelButton: false,
              showConfirmButton: false
            });
          },
          success: function(response, textStatus, jqXHR) {
            Swal.close();
            Swal.fire({
              title: '¡Proceso iniciado correctamente!',
              text: 'El envío de recordatorios inició sin problemas.',
              icon: 'success',
              allowEscapeKey: false,
              allowEnterKey: false,
              buttonsStyling: false,
              allowOutsideClick: false,
              customClass: {
                confirmButton: "btn btn-fj-purple",
              }
            });
          },
          error: function(jqXHR, textStatus, errorThrown) {
            // Muestra alerta indicando que hubo un error
            Swal.fire({
              text: 'Hubo un problema al intentar realizar el envio. Por favor vuelve a intentar en unos minutos.',
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn btn-fj-purple"
              }
            });
          }
        })
      }
    })
  })
})

$(document).ready(function() {
  // Evento para limpiar los usuarios seleccionados cuando se realiza un filtros
  $('form#form-postulant-filter').on('submit', function() {
    let form = $(this);
    cleanSelectedCandidates(form);
  });

  // Evento para limpiar los usuarios seleccionados cuando se borran los filtros
  $('#clean-filter-btn').on('click', function(e) {
    let form = $("form#form-postulant-filter");    
    cleanSelectedCandidates(form);
  });
})

function swipeToRequest(swipeToBtnAction) {
  var btn = swipeToBtnAction;
  var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
  var href = btn.data('href')
  var all_id_array = "";

  if ($("#fulfill-postulants-tab.active").length > 0) {
    all_id_array = $('input#all_ids_fulfill').val();
  } else if ($("#no-fulfill-postulants-tab.active").length > 0) {
    all_id_array = $('input#all_ids_no_fulfill').val();
  } else {
    all_id_array = $('input#all_ids_no_tabs').val();
  }
  
  var queryParams = window.location.search;
  if (queryParams) queryParams = queryParams.replace('?', '&');

  var requestUrl = queryParams ?  href + queryParams : href
  var isDisabled = btn.hasClass('disabled')
  
  if (isDisabled) return;

  $('button.swipe-btn').addClass('disabled');

  $.ajax({
    type: "GET",
    url: requestUrl,
    dataType: 'script',
    data: {
      authenticity_token: AUTH_TOKEN,
      all_postulants: all_id_array
    },
    beforeSend: function() {
      Swal.fire({
        title: 'Cargando',
        icon: 'info',
        allowEscapeKey: false,
        allowEnterKey: false,
        buttonsStyling: false,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false
      });
    },
    success: function(response) {
      $('button.swipe-btn').removeClass('disabled');
      handleModalFooterSwipeButtons();
      Swal.close();
    },
    error: function(xhr, status, error) {
      $('button.swipe-btn').removeClass('disabled');
      $('#profileModal button.swipe-btn').addClass('d-none');
      Swal.fire({
        text: 'Hubo un problema al cambiar de postulante. Intente cambiar manualmente. Si el problema se repite, contáctenos.',
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn btn-fj-purple"
        }
      });
    }
  });
}

function handleModalFooterSwipeButtons() {
  var swipeNextBtn = $("#swipe-actions button.swipe-btn.next"); 
  var swipePreviousBtn = $("#swipe-actions button.swipe-btn.previous");

  var modalSwipeNextBtn = $("#modal-footer-swipe-actions button.swipe-btn.next"); 
  var modalSwipePreviousBtn = $("#modal-footer-swipe-actions button.swipe-btn.previous");

  if (swipeNextBtn.length > 0 && modalSwipeNextBtn.length > 0) {
    var isShown = !swipeNextBtn.hasClass('d-none');
    if (isShown) {
      modalSwipeNextBtn.removeClass('d-none disabled');
    } else {
      modalSwipeNextBtn.addClass('d-none disabled');
    }
  } else {
    modalSwipeNextBtn.addClass('d-none disabled');
  }

  if (swipePreviousBtn.length > 0 && modalSwipePreviousBtn.length > 0) {
    var isShown = !swipePreviousBtn.hasClass('d-none');
    if (isShown) {
      modalSwipePreviousBtn.removeClass('d-none disabled');
    } else {
      modalSwipePreviousBtn.addClass('d-none disabled');
    }
  } else {
    modalSwipePreviousBtn.addClass('d-none disabled');
  }
}

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;

	let currentTranslation;
	let firstIteration = true;

	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {

      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}

// Función para obtener el slug y verificar si el usuario es admin
function getSlugAndAdminStatus() {
  var isAdminUser = false;
  var slug = '';

  if ($("#postulants-fulfill").length) {
    isAdminUser = $("#postulants-fulfill").hasClass("admin");
    slug = $("#postulants-fulfill").attr("data-slug");
  } else if ($("#postulants-no-fulfill").length) {
    isAdminUser = $("#postulants-no-fulfill").hasClass("admin");
    slug = $("#postulants-no-fulfill").attr("data-slug");
  } else if ($("#postulants").length) {
    isAdminUser = $("#postulants").hasClass("admin");
    slug = $("#postulants").attr("data-slug");
  }

  return { isAdminUser, slug };
}

// Función para construir la URL dependiendo del rol del usuario y la pestaña activa
function getMassiveChangeUrl(stateLink, slug, is_admin) {
  if (is_admin) {
    return '/admin/clientes/' + slug + '/ofertas/' + stateLink.data('ofert') + '/postulaciones/change_massive_funnel_state';
  } else {
    return '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/change_massive_funnel_state';
  }
}

function swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel, data = undefined, showPreview = false) {
  var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
  var postulationId = stateLink.data('postulation');
  var postulationList = $('#postulants tbody tr');

  if ($("#fulfill-postulants-tab.active").length > 0) {
    postulationList = $('#table-fulfill tbody tr');
  } else if ($("#no-fulfill-postulants-tab.active").length > 0) {
    postulationList = $('#table-no-fulfill tbody tr');
  } else {
    postulationList = $('#table-no-tabs tbody tr');
  }

  var postulationIndex =  postulationList.index($('#postulant-'+postulationId));
  var postulationCount = postulationList.length;
  let swalFireOptions = defineSwalFireOptionForStatusChange(data, swalFireInfo, showPreview, newStateLabel);

  Swal.fire(swalFireOptions)
  .then(function(result) {
    // Se revisa si se debe enviar correo o no
    var sendMail = $('#swal-checkbox').is(':checked') ? 'si' : 'no';

    var { isAdminUser, slug } = getSlugAndAdminStatus();

    var url = isAdminUser
    ? '/admin/clientes/' + slug + '/ofertas/' + stateLink.data('ofert') + '/postulaciones/'+ stateLink.data('postulation')+'/change_funnel_state'
    : '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/'+ stateLink.data('postulation')+'/change_funnel_state';

    if (result.isConfirmed) {
      $.ajax({
        type: "POST",
        url: url,
        dataType: 'script',
        data: {
          postulation_id: stateLink.data('postulation'),
          new_state: stateLink.data('funnel-workflow'),
          send_mail: sendMail,
          slug: slug,
          postulation_index: postulationIndex,
          postulation_count: postulationCount,
          authenticity_token: AUTH_TOKEN
        }
      });
    }
  })
}

function swalFireChangeMassiveStatus(swalFireInfo, stateLink, postulation_ids, newStateLabel, data = undefined, showPreview = false) {
  var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
  let swalFireOptions = defineSwalFireOptionForStatusChange(data, swalFireInfo, showPreview, newStateLabel, postulation_ids);
  
  Swal.fire(swalFireOptions)
  .then(function(result) {
    // Se revisa si se debe enviar correo o no
    var sendMail = $('#swal-checkbox').is(':checked') ? 'si' : 'no';

    var { isAdminUser, slug } = getSlugAndAdminStatus();

    var url = getMassiveChangeUrl(stateLink, slug, isAdminUser);

    if (result.isConfirmed) {
      $.ajax({
        type: "POST",
        url: url,
        dataType: 'script',
        data: {
          postulation_ids: postulation_ids,
          new_state: stateLink.data('funnel-workflow'),
          send_mail: sendMail,
          slug: slug,
          authenticity_token: AUTH_TOKEN
        }
      });
    }
  })
}

function defineSwalFireOptionForStatusChange(data, swalFireInfo, showPreview, newStateLabel, postulation_ids = "") {
  var isDataPresent = data != undefined;
  // Las opciones se crean con los valores del Swalfire de no envío de correos
  let swalFiretitle = swalFireInfo['title'].replace("[--stateLabel--]", newStateLabel);
  swalFiretitle = swalFiretitle.replace("[--nPostulants--]", postulation_ids.split(",").length);

  let swalFireOptions = {
    title: swalFiretitle,
    icon: 'question',
    confirmButtonText: swalFireInfo['confirmButtonText'],
    showCancelButton: true,
    cancelButtonText: swalFireInfo['cancelButtonText'],
    width: '50rem',
    padding: '2rem'
  }
  // Se modifican las opciones para que se adapte al preview de correos
  if (isDataPresent && data["email_subject"] && data["email_message"]) {
    const showPreviewText = getTranslationValue(config, [language, "preview_email_btn", "show"], "Preview del Correo");
    var subject = data["email_subject"];
    var body = data["email_message"];
    var previewContainer = `
      <button id="preview-button-email" class="btn btn-secondary mt-4">${showPreviewText}</button>
      <div id="email-preview" style="display: none; margin: 10px 20px 0 20px;">
        <div id="email-preview-content" style="text-align: justify; margin-top:25px;">
        <strong>Asunto:</strong><br>${subject}
        <br><br>
        <strong>Cuerpo:</strong><br>${body}
        </div>
      </div>
    `;
    swalFireOptions.width = '70rem'
    swalFireOptions.html = `
      <div>
        <input type="checkbox" id="swal-checkbox">
        <label for="swal-checkbox">${swalFireInfo['inputPlaceholder']}</label>
      </div>
      ${ (isDataPresent && showPreview) ? previewContainer : "" }
    `;
    swalFireOptions.customClass = {
      content: 'email-preview-container'
    };
  }
  return swalFireOptions
}

function updateQueryParam(url, param, value) {
  var baseUrl = url.split('?')[0]; // Obtiene la url base
  var queryParams = url.split('?')[1]; // Obtiene los query params
  var newQueryParams = '';

  if (queryParams) {
      var params = new URLSearchParams(queryParams);
      params.set(param, value); // Establece el nuevo valor del parámetro (lo agrega si no existe)
      newQueryParams = params.toString();
  } else {
      newQueryParams = `${param}=${value}`;
  }

  return `${baseUrl}?${newQueryParams}`;
}

// Independiente del tipo de proceso, retorna todos los postulantes seleccionados
function getSelectedPostulations() {
  const jobId = $("#list_postulations").data("job");
  console.log(jobId)
  const fulfillIds = localStorage.getItem("postulantIds_postulants-fulfill_" + jobId);
  const noFulfillIds = localStorage.getItem("postulantIds_postulants-no-fulfill_" + jobId);
  const noTabsIds = localStorage.getItem("postulantIds_postulants_" + jobId);
  return [...(fulfillIds ? fulfillIds.split(',') : []), ...(noFulfillIds ? noFulfillIds.split(',') : []), ...(noTabsIds ? noTabsIds.split(',') : [])];
}

// Limpia las selecciones de postulantes
function cleanSelectedCandidates(form) {
  let submitUrlSplitted = form.attr("action").split("/");
  let ofertId = submitUrlSplitted[submitUrlSplitted.length - 2];

  // Resetear los valores en localStorage
  ["postulantIds_postulants-fulfill_","postulantIds_postulants-no-fulfill_","postulantIds_postulants_"].forEach(function (ls) {
    let idsKey = ls + ofertId
    let ids = localStorage.getItem(idsKey)
    if (ids) localStorage.removeItem(idsKey);
  })
  
  // Desmarcar todos los checkboxes
  $('input#check_for_select_all_no_tabs').prop("checked", false);
  $('input#check_for_select_all_fulfill').prop("checked", false);
  $('input#check_for_select_all_no_fulfill').prop("checked", false);
  $('.check_postulant').prop("checked", false);
}